import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { compose } from "recompose";
import { Table, Button, Modal, ModalFooter, ModalBody, ModalHeader, } from "reactstrap";
import {
  TableContainer,
  TableDataFetch,
  AddNewButton,
  withTable,
  BulkDeleteButton,
  EditDeleteButtons,
  ViewingRecords,
} from "components/common/Tables/index";
import Page from "components/common/Page";
import ConnectionStatus from "./ConnectionStatus";
import { Trans } from "react-i18next";
import { ApiClient } from "services";
import { NotificationManager } from "react-notifications";
import { useOrganisationContext } from "../../hooks";

import TipSequence from 'components/Tips/TipSequence';

let tips = [
  {
    id: 'organisation-edit',
    text: 'Go to organisation edit page to connect to Xero.',
    targetId: 'organisation-edit',
    position: 'bottom',
    delay: 500
  },
];

export const OrganisationList = ({
  selected,
  match,
  url = "connected_organisations",
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  setOffset,
  search,
  setSearch,
  isDeleteModalOpen,
  toggleDeleteModal,
  onDeleteItem,
  onDeleted,
  refreshToken,
  readOnly,
  filters,
  t,
}) => { 
  const history = useHistory()

  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const [isConfirming, setConfirming] = useState()
  const [organisationToDelete, setOrganisationToDelete] = useState()
  const [viewArchive, setViewArchive] = useState(false)
  const { selectedOrganisation } = useOrganisationContext();

  const closeConfirm = () => {
    setIsConfirmOpen(false)
  }

  const deleteHandler = (id) => { 
    setOrganisationToDelete(id)
    setIsConfirmOpen(true)
  }

  const handleConfirm = () => {
    onUndeleteItem(organisationToDelete)
    closeConfirm()
  }

  const onUndeleteItem = (id) => {
    setConfirming(true)
    ApiClient().post(`${url}/${id}/undelete`).then((res) => {
      NotificationManager.success(
        <Trans>Organisation undeleted successfully.</Trans>
      )
      setConfirming(false)
      setTimeout(() => {
        window.location.reload()
      }, 500)
    }).finally(() => {
      setConfirming(false)
    })
  }

  useEffect(() => {
    if (data?.results?.length > 0) {
      let tip = tips.find(tip => tip.id === 'organisation-edit')
      if (tip) {
        tip.targetId = `organisation-edit-${selectedOrganisation?.id}`

        tip.onComplete = () => {
          history.push(`${match.url}/${selectedOrganisation?.id}`)
        }
      }
    }
  }, [data])

  return (
    <Page title="Organisations" className="inv-table">
      <div className="row">
        <div className="col">
            <AddNewButton
              resource="Organisation"
              match={match}
              className="float-left mb-2"
              readOnly={readOnly}
            />
        </div>
        <div className="col">
          {/* <BulkDeleteButton
            className="float-right mb-2"
            toggleModal={toggleDeleteModal}
            selected={selected}
            url={url}
            onDeleted={onDeleted}
            isModalOpen={isDeleteModalOpen}
            readOnly={readOnly}
            organisation
            /> */}
            {/* Removed as requested from management team as users misuse it*/}
          {/* <button className="btn btn-secondary float-right mb-2" onClick={()=>setViewArchive(!viewArchive)}>
            {viewArchive ? 
              <Trans>Active Organisations</Trans>: <Trans>Archived Organisations</Trans>
            }
          </button> */}
        </div>
      </div>
      <TableContainer
        items={data.results}
        ordering={ordering}
        onOrderingChanged={setOrdering}
        selected={selected}
        onSelectedChanged={setSelected}
      >
        <Table>
          <thead>
            <tr>
              <th select style={{ width: 1 }} />
              <th sortBy="name">
                <Trans>Name</Trans>
              </th>
              <th>
                <Trans>Connections</Trans>
              </th>
              <th>
                <Trans>Status</Trans>
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {data.results.filter((org)=>(viewArchive? org.deleted:!org.deleted)).map((i, index) => (
              <tr key={i.id}>
                <td select />
                <td>{i.name}</td>
                <td style={{maxWidth: 400}}>
                  <ConnectionStatus item={i} showDisconnect={false} />
                </td>
                <td>
                  {
                    i.deleted ? (
                      <Trans>Archived</Trans>
                    ) : (
                      <Trans>Active</Trans>
                    )
                  }
                </td>
                <td className="text-end edit-btn">
                  <EditDeleteButtons
                    url={match.url}
                    id={i.id}
                    onDelete={onDeleteItem}
                    readOnly={readOnly}
                    showDelete={false}
                    deleteText={t("Archive")}
                    showUndelete={!!i.deleted}
                    onUndelete={deleteHandler}
                    editable={!i.deleted}
                    index={index}
                  />
                </td> 
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      <TableDataFetch
        ordering={ordering}
        refreshToken={refreshToken}
        search={search}
        limit={limit}
        url={url}
        offset={offset}
        onDataFetched={setData}
        filters={filters}
      />
      <ViewingRecords
        offset={offset}
        limit={limit}
        count={data.count}
        className="float-left"
      />

      <TipSequence tips={tips} autoStart={data?.results?.length > 0} />

      <Modal isOpen={isConfirmOpen} toggle={closeConfirm}>
        <ModalHeader><Trans>Unarchive</Trans></ModalHeader>
        <ModalBody>
          <Trans>Are you sure you want to unarchive this organisation?</Trans>
        </ModalBody>
        <ModalFooter>
          <Button onClick={closeConfirm}><Trans>Close</Trans></Button>
          {isConfirming ?
            <Button className="mx-0" disabled color="primary"><span className="fa fa-spinner fa-spin" /> <Trans>Unarchiving...</Trans></Button>
            :
            <Button className="mx-0" onClick={handleConfirm} color={"primary"}><Trans>Confirm</Trans></Button>
          }
        </ModalFooter>
      </Modal>
    </Page>
  )
};



const enhance = compose(withTable({ 
  limit: 99, 
  filters: {
    all: true
  },
}));

export default enhance(OrganisationList);
